import React from 'react'
import './about.css'
import ME from '../../assets/3.png'
import { FaAward } from 'react-icons/fa'
// import { FiUsers } from 'react-icons/fi'
// import { VscFolderLibrary } from 'react-icons/vsc'
import { GiGraduateCap } from 'react-icons/gi'


const About = () => {
  return (
    <section id="about">
      <h5>Get To Know</h5>
      <h2>About Me</h2>

      <div className='container about__container'>

        <div className='about__me'>
          <img src={ME} alt="" className="about__me-image" />
          <article className="about__card">
              <div className='about__card__title'>
                <FaAward className='about__icon'/>
                <h5>Experience</h5>
              </div>
              <div className='about__card__content'>
                <small><a href="https://wso2.com/">WSO2</a></small>
                <small><i>Aug 2025 - present</i></small>
              </div>
              <div className='about__card__content'>
                <small><a href="https://www.velou.com/">Velou Engineering</a></small>
                <small><i>Jul 2024 - Jul 2025</i></small>
              </div>
              <div className='about__card__content'>
                <small><a href="https://ivedha.com/">iVedha Inc.</a></small>
                <small><i>Nov 2023 - May 2024</i></small>
              </div>
            </article>

            <article className="about__card">
              <div className='about__card__title'>
                <GiGraduateCap className='about__icon'/>
                <h5>Education</h5>
              </div>
              <div className='about__card__content'>
                <small><a href="https://cmb.ac.lk/category/ucsc">UCSC (BSc. in CS)</a></small>
                <small><i>May 2021 - May 2024</i></small>
              </div>
              <div className='about__card__content'>
                <small><a href="https://mahamayagirlscollege.lk/">MGCK</a></small>
                <small><i>Jan 2005 - Aug 2018</i></small>
              </div>
            </article>
        </div>

        <div className="about__content">
          <div className="about__cards">
            {/* <article className="about__card">
              <FaAward className='about__icon'/>
              <h5>Experience</h5>
              <small>1+</small>
            </article> */}

            {/* <article className="about__card">
              <FiUsers className='about__icon'/>
              <h5>Clients</h5>
              <small>Pending...</small>
            </article> */}

            {/* <article className="about__card">
              <VscFolderLibrary className='about__icon'/>
              <h5>Projects</h5>
              <small>3</small>
            </article> */}

          </div>

          {/* <p>
            I am a passionate and results-driven Software Engineer with over 1 year of industrial experience, specializing in 
            backend development. I hold a degree in Computer Science from the University of Colombo School of Computing and have 
            hands-on experience working with technologies such as Java Spring Boot and Node.js. My expertise lies in designing, 
            developing, and maintaining scalable backend systems and APIs that power robust applications. I am enthusiastic about 
            writing clean, efficient code and continuously expanding my skill set to deliver high-quality software solutions.
            <br /> As part of my future aspirations, I am particularly interested in the field of data science and look
            forward to exploring and learning more about this exciting area. I have a passion for technology and a strong
            desire to make a positive impact in the field.
          </p> */}
          <p>
            I'm a passionate Software Engineer with over a year of industry experience, focused on backend development. 
            I graduated with a degree in Computer Science from the University of Colombo School of Computing, and since then, 
            I've been diving deep into building reliable and scalable backend systems using technologies like Java Spring Boot 
            and Node.js.
            <br />
            What drives me most is the satisfaction of turning ideas into real, working systems that people rely on. I enjoy the 
            challenge of writing clean, efficient code and finding elegant solutions to complex problems.
            <br />
            I'm always eager to learn, grow, and contribute to meaningful projects. I'm constantly exploring new tools, best practices, 
            and ways to build better software that makes a difference.
          </p>


          <a href="#contact" className='btn btn-primary'>Let's Talk</a>
        </div>

      </div>



    </section>
  )
}

export default About